export default __webpack_public_path__ + "static/media/ClioIntegrationHelp.01e9e7ee.gif";